import { initCustoms } from './customs';
import { initComponents } from './components';
import { initVendors } from './vendors';
import './styles.css';

let initialized = false;

export function initCustomUI(): void {
    if (initialized) return;
    initialized = true;

    const turboWindow = window as Window & { Turbo?: { session?: { drive?: boolean } } };
    turboWindow.Turbo?.session?.drive && (turboWindow.Turbo.session.drive = false);
    // my-Drawer / my-select are temporarily disabled.
    // Re-enable by importing and initializing:
    // - './customs/drawer'
    // - './customs/select'
    initCustoms();
    initComponents();
    initVendors();
}
